import {Mapper} from '@s-ui/domain'

export class FromModelDetailFormConfigResponseToModelDetailFormConfigVOMapper extends Mapper {
  constructor({modelDetailFormConfigValueObjectFactory}) {
    super()
    this._modelDetailFormConfigValueObjectFactory = modelDetailFormConfigValueObjectFactory
  }

  map = response => {
    const {fields, showMakeLeadForm, dealerId} = response

    return this._modelDetailFormConfigValueObjectFactory({
      fields,
      contractId: dealerId,
      showForm: showMakeLeadForm
    })
  }
}
